import * as LabelPrimitive from "@radix-ui/react-label";
import { cva, type VariantProps } from "class-variance-authority";
import React, { memo } from "react";

import { cn } from "@/lib/chillnn/cn";

type Props = {
	children: React.ReactNode;
};

export const FormLabel = memo(
	React.forwardRef<HTMLLabelElement, Props>(({ ...props }: Props, ref) => {
		// const { label } = props;

		return <label ref={ref} className="text-gray-900 mb-2 block text-sm font-medium" {...props} />;
	}),
);

const labelVariants = cva("text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70");

const Label = React.forwardRef<
	React.ElementRef<typeof LabelPrimitive.Root>,
	React.ComponentPropsWithoutRef<typeof LabelPrimitive.Root> & VariantProps<typeof labelVariants>
>(({ className, ...props }, ref) => (
	<LabelPrimitive.Root ref={ref} className={cn(labelVariants(), className)} {...props} />
));
Label.displayName = LabelPrimitive.Root.displayName;

export { Label };
